import { Component, OnInit } from "@angular/core";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { ContractService } from "../../../../../auth/service/contract.service";
import { AuthenticationService } from "../../../../../auth/service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-lista-costi-contratti",
  templateUrl: "./lista-costi-contratti.component.html",
  styleUrls: ["./lista-costi-contratti.component.scss"],
})
export class ListaCostiContrattiComponent implements OnInit {
  public contentHeader: IContentHeader;
  private contractList: any = [];
  public loadingTable: boolean = true;
  public filteredCosts: any = [];
  public searchKey: string;
  public searchApprendistato: number = 2;
  public lastUpdate: any = null;

  constructor(
    public _utilService: UtilsService,
    public _contractService: ContractService,
    public _authenticationService: AuthenticationService,
  ) {
    if (!!this._utilService.themeConfiguration.last_employee_contracts_update) {
      this.lastUpdate = this._utilService.formatDate(this._utilService.themeConfiguration.last_employee_contracts_update, "DD/MM/YYYY HH:mm");
    }
  }

  async ngOnInit() {
    this.contentHeader = {
      headerTitle: "TITLES.VIEW_CONTRACTS_COSTS",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "TITLES.MANAGE",
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: "TITLES.VIEW_CONTRACTS_COSTS",
            isLink: false,
          },
        ],
      },
    };

    await this._contractService.getCosts().then((result) => {
      this.loadingTable = false;
      this.contractList = result;
      this.filterList();
    });
  }

  filterList() {
    let filtered: any = this.contractList;

    if (this.searchKey) {
      filtered = filtered.filter((item: any) => JSON.stringify(item).includes(this.searchKey));
    }

    this.searchApprendistato = Number(this.searchApprendistato);

    if (this.searchApprendistato < 2) {
      filtered = filtered.filter((item: any) => item.is_apprendistato === this.searchApprendistato);
    }

    this.filteredCosts = filtered;
  }
}
